export const LINK_MESSAGE = `I hereby declare that I am the address owner.`;

const constants = {
  LINK_MESSAGE,
};
export default constants;
